/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12.75 7.5C12.75 7.9125 12.4125 8.25 12 8.25C11.5875 8.25 11.25 7.9125 11.25 7.5M12.75 7.5C12.75 7.0875 12.4125 6.75 12 6.75C11.5875 6.75 11.25 7.0875 11.25 7.5M12.75 7.5H11.25M12.75 12C12.75 12.4125 12.4125 12.75 12 12.75C11.5875 12.75 11.25 12.4125 11.25 12M12.75 12C12.75 11.5875 12.4125 11.25 12 11.25C11.5875 11.25 11.25 11.5875 11.25 12M12.75 12H11.25M12.75 17C12.75 17.4125 12.4125 17.75 12 17.75C11.5875 17.75 11.25 17.4125 11.25 17M12.75 17C12.75 16.5875 12.4125 16.25 12 16.25C11.5875 16.25 11.25 16.5875 11.25 17M12.75 17H11.25"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M12.75 7.5C12.75 7.9125 12.4125 8.25 12 8.25C11.5875 8.25 11.25 7.9125 11.25 7.5M12.75 7.5C12.75 7.0875 12.4125 6.75 12 6.75C11.5875 6.75 11.25 7.0875 11.25 7.5M12.75 7.5H11.25M12.75 12C12.75 12.4125 12.4125 12.75 12 12.75C11.5875 12.75 11.25 12.4125 11.25 12M12.75 12C12.75 11.5875 12.4125 11.25 12 11.25C11.5875 11.25 11.25 11.5875 11.25 12M12.75 12H11.25M12.75 17C12.75 17.4125 12.4125 17.75 12 17.75C11.5875 17.75 11.25 17.4125 11.25 17M12.75 17C12.75 16.5875 12.4125 16.25 12 16.25C11.5875 16.25 11.25 16.5875 11.25 17M12.75 17H11.25M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39709 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V13.15C22.75 16.5103 22.75 18.1905 22.096 19.4739C21.5208 20.6029 20.6029 21.5208 19.4739 22.096C18.1905 22.75 16.5103 22.75 13.15 22.75H10.85C7.48969 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39709 2.4792 4.52606 1.90396ZM12 6C11.1733 6 10.5 6.67329 10.5 7.5C10.5 8.32671 11.1733 9 12 9C12.8267 9 13.5 8.32671 13.5 7.5C13.5 6.67329 12.8267 6 12 6ZM12 10.5C11.1733 10.5 10.5 11.1733 10.5 12C10.5 12.8267 11.1733 13.5 12 13.5C12.8267 13.5 13.5 12.8267 13.5 12C13.5 11.1733 12.8267 10.5 12 10.5ZM12 15.5C11.1733 15.5 10.5 16.1733 10.5 17C10.5 17.8267 11.1733 18.5 12 18.5C12.8267 18.5 13.5 17.8267 13.5 17C13.5 16.1733 12.8267 15.5 12 15.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H15C15.9288 22 16.3933 22 16.7832 21.9487C19.4756 21.5942 21.5942 19.4756 21.9487 16.7832C22 16.3933 22 15.9288 22 15V15V14.5M12.75 7.5C12.75 7.9125 12.4125 8.25 12 8.25C11.5875 8.25 11.25 7.9125 11.25 7.5M12.75 7.5C12.75 7.0875 12.4125 6.75 12 6.75C11.5875 6.75 11.25 7.0875 11.25 7.5M12.75 7.5H11.25M12.75 12C12.75 12.4125 12.4125 12.75 12 12.75C11.5875 12.75 11.25 12.4125 11.25 12M12.75 12C12.75 11.5875 12.4125 11.25 12 11.25C11.5875 11.25 11.25 11.5875 11.25 12M12.75 12H11.25M12.75 17C12.75 17.4125 12.4125 17.75 12 17.75C11.5875 17.75 11.25 17.4125 11.25 17M12.75 17C12.75 16.5875 12.4125 16.25 12 16.25C11.5875 16.25 11.25 16.5875 11.25 17M12.75 17H11.25"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12.75 7.5C12.75 7.9125 12.4125 8.25 12 8.25C11.5875 8.25 11.25 7.9125 11.25 7.5M12.75 7.5C12.75 7.0875 12.4125 6.75 12 6.75C11.5875 6.75 11.25 7.0875 11.25 7.5M12.75 7.5H11.25M12.75 12C12.75 12.4125 12.4125 12.75 12 12.75C11.5875 12.75 11.25 12.4125 11.25 12M12.75 12C12.75 11.5875 12.4125 11.25 12 11.25C11.5875 11.25 11.25 11.5875 11.25 12M12.75 12H11.25M12.75 17C12.75 17.4125 12.4125 17.75 12 17.75C11.5875 17.75 11.25 17.4125 11.25 17M12.75 17C12.75 16.5875 12.4125 16.25 12 16.25C11.5875 16.25 11.25 16.5875 11.25 17M12.75 17H11.25M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.4792 3.39708 1.90396 4.52606C1.25 5.80953 1.25 7.48969 1.25 10.85L1.25 13.15C1.25 16.5103 1.25 18.1905 1.90396 19.4739C2.4792 20.6029 3.39708 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5 7.5C10.5 6.67329 11.1733 6 12 6C12.8267 6 13.5 6.67329 13.5 7.5C13.5 8.32671 12.8267 9 12 9C11.1733 9 10.5 8.32671 10.5 7.5ZM10.5 12C10.5 11.1733 11.1733 10.5 12 10.5C12.8267 10.5 13.5 11.1733 13.5 12C13.5 12.8267 12.8267 13.5 12 13.5C11.1733 13.5 10.5 12.8267 10.5 12ZM10.5 17C10.5 16.1733 11.1733 15.5 12 15.5C12.8267 15.5 13.5 16.1733 13.5 17C13.5 17.8267 12.8267 18.5 12 18.5C11.1733 18.5 10.5 17.8267 10.5 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
